import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  BarChart3,
  Edit3,
  Eye,
  Share2,
  Trash2,
  ListChecks,
  Users,
} from 'lucide-react';
import ExpirationBadge from './ExpirationBadge';

// Карточка квиза в списке «Мои квизы». Без бизнес-логики — только данные.
const QuizCard = ({ quiz, onShare, onDelete }) => {
  const { t } = useTranslation();
  return (
    <article className="rounded-2xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 shadow-sm hover:shadow-md transition flex flex-col overflow-hidden">
      {/* Обложка (WebP) — fallback на градиент */}
      <div className="relative aspect-[16/8] bg-gradient-to-br from-indigo-500 via-purple-500 to-fuchsia-500">
        {quiz.coverImageWebpUrl && (
          <img
            src={quiz.coverImageWebpUrl}
            alt=""
            loading="lazy"
            className="absolute inset-0 w-full h-full object-cover"
            onError={(e) => { e.currentTarget.style.display = 'none'; }}
          />
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" />
        <div className="absolute right-3 top-3">
          <ExpirationBadge expiresAt={quiz.expiresAt} status={quiz.status} className="shadow-sm" />
        </div>
      </div>

      <div className="p-5 flex flex-col gap-4 flex-1">
        <div className="min-w-0">
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white break-words line-clamp-2">
            {quiz.title}
          </h3>
          {quiz.description && (
            <p className="mt-1 text-sm text-gray-500 dark:text-gray-400 line-clamp-2 break-words [overflow-wrap:anywhere]">
              {quiz.description}
            </p>
          )}
        </div>

      <div className="flex flex-wrap items-center gap-2 text-xs text-gray-500 dark:text-gray-400">
        <span className="inline-flex items-center gap-1 rounded-full bg-gray-100 dark:bg-gray-800 px-2.5 py-1">
          <ListChecks className="w-3.5 h-3.5" />
          {t('quiz.card.questions', { count: quiz.questions?.length || 0 })}
        </span>
        <span className="inline-flex items-center gap-1 rounded-full bg-gray-100 dark:bg-gray-800 px-2.5 py-1">
          <Users className="w-3.5 h-3.5" />
          {t('quiz.card.completions', { count: quiz.completionsCount || 0 })}
        </span>
        <span className="inline-flex items-center gap-1 rounded-full bg-gray-100 dark:bg-gray-800 px-2.5 py-1">
          <Eye className="w-3.5 h-3.5" />
          {t('quiz.card.views', { count: quiz.viewsCount || 0 })}
        </span>
      </div>

      <div className="flex flex-wrap gap-2 mt-auto">
        <button
          type="button"
          onClick={() => onShare(quiz)}
          className="inline-flex items-center gap-1.5 rounded-xl bg-indigo-600 hover:bg-indigo-700 text-white px-3 py-2 text-sm font-medium transition"
        >
          <Share2 className="w-4 h-4" /> {t('quiz.card.share')}
        </button>
        <Link
          to={`/dashboard/student/quizzes/${quiz._id}/stats`}
          className="inline-flex items-center gap-1.5 rounded-xl border border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-800 px-3 py-2 text-sm font-medium text-gray-700 dark:text-gray-200 transition"
        >
          <BarChart3 className="w-4 h-4" /> {t('quiz.card.stats')}
        </Link>
        <Link
          to={`/dashboard/student/quizzes/${quiz._id}/edit`}
          className="inline-flex items-center gap-1.5 rounded-xl border border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-800 px-3 py-2 text-sm font-medium text-gray-700 dark:text-gray-200 transition"
        >
          <Edit3 className="w-4 h-4" /> {t('quiz.card.edit')}
        </Link>
        <button
          type="button"
          onClick={() => onDelete(quiz)}
          className="ml-auto inline-flex items-center gap-1.5 rounded-xl border border-red-200 dark:border-red-900/40 hover:bg-red-50 dark:hover:bg-red-950/20 text-red-600 dark:text-red-400 px-3 py-2 text-sm font-medium transition"
        >
          <Trash2 className="w-4 h-4" /> {t('quiz.card.delete')}
        </button>
        </div>
      </div>
    </article>
  );
};

export default QuizCard;
